import React, {useEffect, useMemo, useState} from "react";
import Timeout from "../Timeout";
import moment from "moment";
import "./style.scss";
import {useLocaleContext} from "../../../../context/LocaleContext";
import {isCurrentDayEpisode} from "../../../../helpers/schedule-helper";

export default ({event, stream}) => {
    const {get, getProperty} = useLocaleContext();
    const className = 'stream-player-overlay-paused';
    const [now, setNow] = useState(null)

    useEffect(() => {
        const handler = () => setNow(Math.round(Date.now() / 1000));
        const timer = setInterval(handler, 1000);
        handler();

        return () => clearInterval(timer);
    }, []);

    const nextEpisode = stream?.episode
        .sort((a, b) => a.timeStart - b.timeStart)
        .find((episode) => episode.timeStop > now)
    ;

    const isCurrentDayNextEpisode = useMemo(() => isCurrentDayEpisode(nextEpisode), [nextEpisode]);

    if (!nextEpisode) {
        return (
            <div className={className}>
                <h1>{get(`broadcast.overlay.break.title`)}</h1>
            </div>
        );
    }

    if (nextEpisode.timeStart < now) {
        return (
            <div className={className}>
                <h1>{get(`broadcast.overlay.interrupted.title`)}</h1>
            </div>
        )
    }

    if (!isCurrentDayNextEpisode) {
        return (
            <div className={className}>
                <h1>{get(`broadcast.overlay.stoppedToday.title`)}</h1>
            </div>
        )
    }

    return (
        <div className={className}>
            <h1>{get(`broadcast.overlay.break.title`)} {get(`broadcast.overlay.break.startIn`)}</h1>
            <Timeout time={moment.unix(nextEpisode.timeStart)} />
            <div className={`${className}-nextEpisode-title`}>{get(`broadcast.overlay.break.nextEpisode`)}</div>
            <h1>{getProperty(nextEpisode, 'name')}</h1>
        </div>
    );
}
